export class CancellationTokenManager {
  private controllers: Map<string, AbortController>;

  public constructor() {
    this.controllers = new Map();
  }

  public getSignalAndCancelPrevious(key: string) {
    this.cancel(key);

    const controller = new AbortController();
    this.controllers.set(key, controller);

    return controller.signal;
  }

  public cancel(key: string) {
    if (this.controllers.has(key)) {
      (this.controllers.get(key) as AbortController).abort();

      this.controllers.delete(key);
    }
  }

  public cancelAll() {
    this.controllers.forEach((_controller, key) => this.cancel(key));

    this.controllers.clear();
  }
}
